import ManageAppointments from '@/components/make-new-appointment/manage-appointments.vue';
import NewAppointment from '@/components/make-new-appointment/new-appointment-layout.vue';
import AppointmentAcknowledgementDetails from '@/components/make-new-appointment/appointment-acknowledgement.vue'
import AppLayout from '@/layout/AppLayout.vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import EnquireAppointmentLayout from '@/components/enquire-appointment-details/enquire-appointment-layout.vue';
import ViewAppointmentDetails from '@/components/enquire-appointment-details/view-appointment-details.vue';
import CancelAppointment from '@/components/enquire-appointment-details/cancel-appointment.vue';
import CancelAppointmentPage from '@/components/enquire-appointment-details/cancel-appointment-page.vue';
import EnquireAppointmentDetails from '../components/enquire-appointment-details/enquire-appointment-details.vue';


const router = createRouter({
    history: createWebHashHistory(),

    routes: [
        {
            path: "/",
            component: ManageAppointments
        },
    	{
			path: "/newappointment",
			component: NewAppointment
		},
        {
            path: "/enquireappointment/:number",
            component: EnquireAppointmentLayout
        },
        {
            path: "/enquireappointmentdetails",
            component: EnquireAppointmentDetails
        },
        {
            path: "/viewappointmentdetails",
            component: ViewAppointmentDetails
        },
        {
            path: "/cancelappointment",
            component: CancelAppointment
        },
        {
            path: "/AppointmentAcknowledgementDetails",
            component: AppointmentAcknowledgementDetails
        },
        {
            path: "/cancelappointmentpage",
            component: CancelAppointmentPage
        }
    ]
});

export default router;
